import { requestFactory } from '@/plugins/axios'
export function getWorkOrder(params) {
   return requestFactory({
        url: '/productOrderItem/findById',
        method: 'GET',
        params: params
      })
}
export function getProcess(params) {
   return requestFactory({
        url: '/productOrder/detailedInformation',
        method: 'GET',
        params: params
      })
}
export function getfetch(params) {
   return requestFactory({
        url: '/machine/findOrderId',
        method: 'GET',
        params: params
      })
}
